import { callEmbeddedAgent } from "./callEmbeddedAgent-ffwEeqdP.js";
import { createWhoamiTool } from "./whoami-DU_KhHDm.js";
import { systemPrompt } from "./config-ChOUIglS.js";
import { createIssueEventFieldsTool } from "./utils-_4r1K2PE.js";
import { z } from "zod";

//#region src/tools/support/search-issue-events/agent.ts
const searchIssueEventsAgentOutputSchema = z.object({
	query: z.string().describe("Sentry query filters for tags/fields (NOT including issue: prefix - handler adds that)"),
	fields: z.array(z.string()).describe("Array of field names to return in results"),
	sort: z.string().describe("Sort parameter for results (e.g., -timestamp)"),
	timeRange: z.union([
		z.object({ statsPeriod: z.string().describe("Relative time period like '1h', '24h', '7d', '14d'") }),
		z.object({
			start: z.string().describe("ISO 8601 start time"),
			end: z.string().describe("ISO 8601 end time")
		}),
		z.null()
	]).describe("Time range for filtering events. Use either statsPeriod for relative time or start/end for absolute time. Use null for default 14-day window."),
	explanation: z.string().default("").describe("Brief explanation of how you translated this query")
}).refine((data) => {
	if (!data.sort || !data.fields || data.fields.length === 0) return true;
	const sortField = data.sort.startsWith("-") ? data.sort.substring(1) : data.sort;
	return data.fields.includes(sortField);
}, { message: "Sort field must be included in the fields array. Sentry requires that any field used for sorting must also be explicitly selected. Add the sort field to the fields array or choose a different sort field that's already included." });
/**
* Search issue events agent - translates natural language queries to Sentry tag filters for events within a specific issue
* Returns both the translated query result AND the tool calls made by the agent
*/
async function searchIssueEventsAgent(options) {
	const issueEventFieldsTool = createIssueEventFieldsTool({
		apiService: options.apiService,
		organizationSlug: options.organizationSlug,
		projectId: options.projectId
	});
	const whoamiTool = createWhoamiTool({ apiService: options.apiService });
	return await callEmbeddedAgent({
		system: systemPrompt,
		prompt: options.query,
		tools: {
			issueEventFields: issueEventFieldsTool,
			whoami: whoamiTool
		},
		schema: searchIssueEventsAgentOutputSchema
	});
}

//#endregion
export { searchIssueEventsAgent, searchIssueEventsAgentOutputSchema };
//# sourceMappingURL=agent-Bbb5dUlD.js.map